import { RICOS_VERSION } from './../../ricos-schema/next-schema';
import type { Helpers } from './../../ricos-types';

import type { ContentViewerProps } from '../types';

export const applyBIGenerics =
  (getContentId: () => string | undefined) =>
  ({ helpers = {}, ...rest }: Partial<ContentViewerProps>): Partial<ContentViewerProps> => ({
    ...rest,
    helpers: {
      ...helpers,
      onViewerLoaded: args =>
        helpers.onViewerLoaded?.({ ...args, version: RICOS_VERSION, contentId: getContentId() }),
      onViewerAction: (pluginId, actionName, value, contentId, partialNode) =>
        helpers.onViewerAction?.(
          pluginId,
          actionName,
          value,
          contentId || getContentId(),
          partialNode
        ),
    } as Helpers,
  });
